//  全局按钮颜色调整
export default {
    primary: '#626aef',
    warning: '#fd9133',
    danger: '#f10215',
}